import { useState, useEffect } from "react";
import "./Pagos.css";

export default function Pagos() {
  const [autoMensajes, setAutoMensajes] = useState(false);
  const [mostrarEditor, setMostrarEditor] = useState(false);
  const [mensaje, setMensaje] = useState(
    "Estimado cliente, le recordamos que tiene un pago pendiente el día de hoy. Por favor realice su pago lo antes posible."
  );

  const [fecha, setFecha] = useState(new Date().toISOString().split("T")[0]);

  const [pagos, setPagos] = useState([
    {
      id: 1,
      cliente: "Juan Pérez",
      prestamoId: 102,
      pagoNumero: "5/12",
      horaLimite: "15:00",
      pagado: false,
      fechaPago: "",
    },
    {
      id: 2,
      cliente: "María López",
      prestamoId: 88,
      pagoNumero: "3/12",
      horaLimite: "15:00",
      pagado: false,
      fechaPago: "",
    },
    {
      id: 3,
      cliente: "Carlos Ruiz",
      prestamoId: 77,
      pagoNumero: "10/12",
      horaLimite: "15:00",
      pagado: true,
      fechaPago: "12:40",
    },
  ]);

  const horaActual = new Date();
  const horaLimite = new Date();
  horaLimite.setHours(19, 0, 0, 0);

  const marcarPagado = (id) => {
    setPagos((prev) =>
      prev.map((p) =>
        p.id === id
          ? { ...p, pagado: true, fechaPago: horaActual.toLocaleTimeString() }
          : p
      )
    );
  };

  const enviarRecordatorio = (id) => {
    alert(`Mensaje enviado a ${pagos.find((p) => p.id === id).cliente}:\n\n${mensaje}`);
  };

  const aplicarMulta = (id) => {
    alert(`Multa aplicada al pago #${id}`);
  };

  const obtenerEstatus = (pago) => {
    if (pago.pagado) return "pagado";
    if (horaActual > horaLimite) return "atrasado";
    return "entiempo";
  };

  return (
    <div className="pagos-container">

      {/* 🔥 Título */}
      <div className="pagos-header">
        <h1>Pagos del día</h1>

        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          className="fecha-selector"
        />
      </div>

      {/* 🔥 Switch + Botón Personalizar */}
      <div className="auto-msg-box">
        <label className="switch">
          <input
            type="checkbox"
            checked={autoMensajes}
            onChange={() => setAutoMensajes(!autoMensajes)}
          />
          <span className="slider"></span>
        </label>

        <span className="auto-msg-text">
          Enviar mensajes automáticos después de las 3pm
        </span>

        {/* 🔥 Botón Personalizar */}
        <button
          className="btn-personalizar"
          onClick={() => setMostrarEditor(true)}
        >
          Personalizar mensaje
        </button>
      </div>

      {/* 🔥 Modal para editar mensaje */}
      {mostrarEditor && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Personalizar mensaje</h3>

            <textarea
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              className="modal-textarea"
            />

            <div className="modal-buttons">
              <button
                className="btn-cancelar"
                onClick={() => setMostrarEditor(false)}
              >
                Cancelar
              </button>

              <button
                className="btn-guardar"
                onClick={() => setMostrarEditor(false)}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔥 Tabla */}
      <table className="pagos-table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Préstamo</th>
            <th>Pago</th>
            <th>Estatus</th>
            <th>Hora límite</th>
            <th>Acción</th>
          </tr>
        </thead>

        <tbody>
          {pagos.map((p) => {
            const estatus = obtenerEstatus(p);

            return (
              <tr key={p.id}>
                <td>{p.cliente}</td>
                <td>#{p.prestamoId}</td>
                <td>{p.pagoNumero}</td>

                <td>
                  <span className={`estatus estatus-${estatus}`}>
                    {estatus === "pagado"
                      ? "Pagado"
                      : estatus === "atrasado"
                      ? "Atrasado"
                      : "En tiempo"}
                  </span>
                </td>

                <td>{p.horaLimite}</td>

                <td>
                  {estatus === "pagado" && (
                    <span className="pagado-text">✓ Pagado</span>
                  )}

                  {!p.pagado && estatus === "entiempo" && (
                    <button
                      className="btn-pagar"
                      onClick={() => marcarPagado(p.id)}
                    >
                      Marcar pagado
                    </button>
                  )}

                  {!p.pagado && estatus === "atrasado" && (
                    <div className="acciones-atrasado">
                      <button
                        className="btn-recordatorio"
                        onClick={() => enviarRecordatorio(p.id)}
                      >
                        Enviar recordatorio
                      </button>

                      <button
                        className="btn-multa"
                        onClick={() => aplicarMulta(p.id)}
                      >
                        Aplicar multa
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}